// Module
var code = "<div class=\"mt-auto mb-auto\">\r\n    <p class=\"text-center\">Hold on tight, we're getting your website ready...</p>\r\n    <spinner></spinner>\r\n</div>";
// Exports
export default code;